import { useTranslation } from 'next-i18next';
import { DSIcon, DSText, DSBanner, DSLink } from '@stihl-design-system/components';

import { useLinksByUserLocale } from '@phoenix/core/frontend/shared/feature/global-links/use-links-by-user-locale';
import { GlobalLink } from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation.model';
import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';

export const CallToAction = ({ allowReferrer = false }) => {
  const { t } = useTranslation();
  const { data } = useLinksByUserLocale(['my-stihl-call-to-action']);
  const link = data?.['my-stihl-call-to-action'] ?? { name: undefined, url: '#' };
  const { name, url, eventName } = link as GlobalLink;

  return name && url !== '#' ? (
    <DSBanner role="region" aria-labelledby="call-to-action-link-text" variant="highlight" className="content-center p-0">
      <DSLink
        className="grow items-center justify-center p-2"
        href={url}
        target="_blank"
        rel={allowReferrer ? undefined : 'noreferrer'}
        onClick={eventName ? () => GA.sendEvent({ event_name: eventName, name, url, fromUrl: window?.location?.href }) : undefined}
      >
        <span className="inline-flex items-center gap-2">
          <DSText id="call-to-action-link-text" weight="bold">
            {name}
          </DSText>
          <span className="sr-only">({t('shared:shared_a11y_hint_opensInNewTab')})</span>
          <DSIcon name="chevron-right" />
        </span>
      </DSLink>
    </DSBanner>
  ) : null;
};
